<template>
<div class="chapter">
<div class="inner_page">
<p> </p>
<p> </p>
<p class="dedication"><em class="italic">I dedicate this work to two proletarian revolutionaries:</em></p>
<p class="dedication"><em class="italic">to one now dead, dear Vassili Nikiforovich Chadayev, militant in the Leningrad communist organization, 1917–28, whose principled intelligence, firmness of character and absolute devotion—a unique flame burning within him—never wavered even in the bitterest torment and who perished before he could show the fullness of his powers in the service of the revolution, murdered while accomplishing a mission on 26 August 1928, not far from Armavir (Kuban); and</em></p>
<p class="dedication"><span>TO A GREAT LIVING REVOLUTIONARY.</span></p>
<p class="dedication"><span>V.S.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e7dbfae4